import React from "react";
import { shape, string, func } from "prop-types";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";

const TaxpayerItem = ({ taxpayer, handleDelete }) => {
    const options = [
        {
            text: "vep.taxpayer.delete",
            textType: "I18N",
            func: () => handleDelete(),
        },
    ];

    return (
        <>
            <GridTable.Data className="ellipsis cuit">
                <CustomData
                    dataClass="ellipsis"
                    titleText="vep.taxpayer.cuit"
                    titleTextType="I18N"
                    valueText={taxpayer.cuit}
                    valueClass="ellipsis"
                />
            </GridTable.Data>
            <GridTable.Data className="reference">
                <CustomData
                    dataClass="ellipsis"
                    titleText="vep.taxpayer.reference"
                    titleTextType="I18N"
                    valueText={taxpayer.denomination}
                    valueClass="ellipsis"
                />
            </GridTable.Data>

            <GridTable.Data className="menu">
                {options.length > 0 && (
                    <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
                )}
            </GridTable.Data>
        </>
    );
};

TaxpayerItem.propTypes = {
    taxpayer: shape({
        cuit: string,
        denomination: string,
    }).isRequired,
    handleDelete: func.isRequired,
};

export default TaxpayerItem;
